/* AccountPresence — صَفحة مُستَقِلّة لِبَيانات وظُهور المحامي العامّ.
   تُفتَح من زرّ "إكمال التَّسجيل" في بِطاقتي. */
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { createPortal } from "react-dom";
import { CaretRight } from "@phosphor-icons/react";
import { useUser } from "../context/UserAuthContext";
import PublicPresenceSection from "../components/account/PublicPresenceSection";

function PageHeader({ onBack }) {
  return createPortal(
    <header
      className="lg:hidden fixed top-0 inset-x-0 z-50"
      dir="rtl"
      style={{
        paddingTop: "calc(env(safe-area-inset-top, 0px) + 12px)",
        paddingBottom: "10px",
        background:
          "linear-gradient(180deg, rgba(255,255,255,0.95) 0%, rgba(255,255,255,0.78) 60%, rgba(255,255,255,0) 100%)",
        backdropFilter: "blur(10px)",
        WebkitBackdropFilter: "blur(10px)",
      }}
    >
      <div className="px-4 flex items-center justify-between">
        <button
          type="button"
          onClick={onBack}
          aria-label="رُجوع"
          data-testid="presence-back"
          className="w-10 h-10 rounded-full bg-white shadow-[0_2px_8px_rgba(10,25,47,0.10)] flex items-center justify-center active:scale-95 transition-transform"
        >
          <CaretRight size={20} weight="bold" className="text-[#0A192F]" />
        </button>
        <div className="flex-1 text-center px-3">
          <h2 className="text-[15px] font-bold text-[#0A192F] leading-tight">بَياناتي وظُهوري</h2>
          <p className="text-[11px] text-[#5A6470] mt-0.5">إكمال التَّسجيل وإعداد البِطاقة العامّة</p>
        </div>
        <div className="w-10 h-10" aria-hidden="true" />
      </div>
    </header>,
    document.body,
  );
}

export default function AccountPresence() {
  const navigate = useNavigate();
  const { user, refresh } = useUser();

  // بَطاقَة الظُّهور وَالأَفتار مَيزَة حَصريّة لِلمُحامين فَقَط. الزُّوّار/العُملاء
  // ليس لَهُم بَطاقَة عُموميّة، لِذا نُحَوِّلُهُم لِصَفحَة الحِساب الرَّئيسيّة بِصَمت.
  useEffect(() => {
    if (user && (user.role || "").toLowerCase() === "client") {
      navigate("/account", { replace: true });
    }
  }, [user, navigate]);

  if (user && (user.role || "").toLowerCase() === "client") {
    return null;
  }

  return (
    <div dir="rtl" className="min-h-[100dvh] font-tajawal bg-[#FAFAFA]">
      <PageHeader onBack={() => navigate("/account")} />
      <div aria-hidden="true" className="lg:hidden" style={{ height: "calc(env(safe-area-inset-top, 0px) + 64px)" }} />
      <main className="px-4 pb-24 max-w-2xl mx-auto" data-testid="account-presence-page">
        <PublicPresenceSection user={user} onSaved={() => refresh && refresh()} />
      </main>
    </div>
  );
}
